import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { STORE_TEST_PROJECT_DASHBOARD, STORE_TEST_PROJECT_RUN_COMPARE } from '../stores/constants';
import { TestProjectStores } from '../stores';
import { HasPermission } from '../../authorization/components/HasPermission';
import { AppPermissions } from '../../authorization/Permissions';
import { TestProjectRunCompareList } from '../components';

const TestProjectRunComparePage: React.FC<TestProjectStores> = ({
    projectTestProjectsRunCompareUI,
    projectTestProjectsDashboardUI
}) => {
    if (!projectTestProjectsRunCompareUI || !projectTestProjectsDashboardUI) {
        return null;
    }

    const testProjectDataStore = projectTestProjectsDashboardUI.currentTestProjectDataStore;

    if (!testProjectDataStore) {
        return null;
    }

    return (
        <HasPermission permissionClaim={AppPermissions.CanManageTestProjects}>
            <TestProjectRunCompareList store={projectTestProjectsRunCompareUI} />
        </HasPermission>
    );
};

export default inject(
    STORE_TEST_PROJECT_RUN_COMPARE,
    STORE_TEST_PROJECT_DASHBOARD
)(observer(TestProjectRunComparePage));
